/**
 * Switch to selected page.
 */
function goto_careers(){

    if(!!document.querySelector('.goto-careers')){

        let linkCareer = document.querySelector(".goto-careers");

        linkCareer.addEventListener("click", () => {
            location.href = "careers.html";
        });
    }
}

goto_careers();

export default goto_careers;